class CustomPopup extends HTMLElement {
  constructor() {
    super();
    this.popup();
  }

  popup() {
    const isMenProduct = this.getAttribute("men-product");
    // console.log('isMenProduct', isMenProduct);
    const target = this.querySelector("[custom-size-chart]");
    const popupContainer = document.querySelector("pop-up");
    target
      ? target.addEventListener("click", (e) => {
          e.preventDefault();
          this.updatePopupContent(isMenProduct);
          popupContainer.classList.add("show");
        })
      : "";
  }

  updatePopupContent(isMenProduct) {
    // console.log('updatePopupContent', isMenProduct);
    const popupContent = document.querySelector("pop-up .popup-content");
    const menSizeChart =
      "https://cdn.shopify.com/s/files/1/0571/5748/4737/files/Men_s_Sizing_Chart_color_bar_1_Medium_0faaf4ba-3bd4-4ae7-b429-0ab42ffa0441.png?v=1666296611";
    const womenSizeChart =
      "https://cdn.shopify.com/s/files/1/0571/5748/4737/files/women_s_size_chart_color_bar_2_Medium_b1b7ec4d-a760-4bda-9ae9-cc9bf42633c7.png?v=1666296611";
    const menMeasurement =
      "https://cdn.shopify.com/s/files/1/0571/5748/4737/files/Photo_Measurement_Guides-01_Medium_131dae2d-6ca3-4dcd-91b9-0802ce991820.png?v=1666296611";
    const womenMeasurement =
      "https://cdn.shopify.com/s/files/1/0571/5748/4737/files/Photo_Measurement_Guides-02_Medium_fcca0533-9ca4-40f1-b337-7aa1a88ff491.png?v=1666296611";
    let sizeChart = isMenProduct == "true" ? `${menSizeChart}` : `${womenSizeChart}`;
    // console.log(sizeChart);

    const html = `
      <h2 class="popup-title">Find Your Size</h2>
      <div class="popup-content-inner">
        <div class="popup-content-tabs">
          <div class="popup-content-tab">
            <h3 class="popup-content-tab-heading"><span id="popup-content-tab-size-guide-heading" class="custom-tab-active">Size Guide</span></h3>
          </div>
          <div class="popup-content-tab">
            <h3 class="popup-content-tab-heading"><span id="popup-content-tab-how-to-measure-heading">How To Measure</span></h3>
          </div>
        </div>
        <img class="popup-content-img" src=${sizeChart} />
      </div>
    `;

    popupContent.innerHTML = html;
    const tabs = [...document.querySelectorAll(".popup-content-tab")];
    const image = document.querySelector(".popup-content-img");
    tabs.forEach((tab) =>
      tab.addEventListener("click", (e) => {
        // console.log(e.target, e.target.getAttribute('id'));

        if (e.target.getAttribute("id") === "popup-content-tab-size-guide-heading") {
          if (
            document.querySelector("#popup-content-tab-how-to-measure-heading.custom-tab-active")
          ) {
            document
              .querySelector("#popup-content-tab-how-to-measure-heading.custom-tab-active")
              .classList.remove("custom-tab-active");
          }
          e.target.classList.add("custom-tab-active");
          if (isMenProduct == "true") {
            image.setAttribute("src", menSizeChart);
          } else {
            image.setAttribute("src", womenSizeChart);
          }
        } else if (e.target.getAttribute("id") === "popup-content-tab-how-to-measure-heading") {
          if (document.querySelector("#popup-content-tab-size-guide-heading.custom-tab-active")) {
            document
              .querySelector("#popup-content-tab-size-guide-heading.custom-tab-active")
              .classList.remove("custom-tab-active");
          }
          e.target.classList.add("custom-tab-active");
          if (isMenProduct == "true") {
            image.setAttribute("src", menMeasurement);
          } else {
            image.setAttribute("src", womenMeasurement);
          }
        } else {
        }
      })
    );
  }
}

customElements.define("custom-popup", CustomPopup);
